import { Reveal, StatusBadge, GoldButton } from "./shared";
import { ShieldCheck } from "lucide-react";

export function ProjectCard({ project, onEnquire, delay = 0 }) {
  return (
    <Reveal delay={delay}>
      <div className="border border-[#D4AF37]/15 bg-[#111111] rounded-[2px] overflow-hidden h-full flex flex-col" data-testid={`project-card-${project.id}`}>
        <div className="grid grid-cols-3 grid-rows-2 gap-0.5 h-[180px]">
          {project.images.slice(0, 3).map((src, i) => {
            const count = Math.min(project.images.length, 3);
            const span =
              count === 1 ? "col-span-3 row-span-2" :
              count === 2 ? "col-span-3 row-span-1" :
              i === 0 ? "col-span-2 row-span-2" : "col-span-1 row-span-1";
            return (
              <div key={i} className={`relative overflow-hidden ${span}`}>
                <img src={src} alt={project.name} className="w-full h-full object-cover img-cinematic" />
              </div>
            );
          })}
        </div>
        <div className="p-6 flex flex-col flex-1">
          <div className="flex items-center justify-between mb-2 gap-3">
            <h3 className="font-serif-lux text-xl text-[#F5F5F0]">{project.name}</h3>
            <StatusBadge status={project.status} />
          </div>
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] mb-4">{project.sector}</p>
          <div className="space-y-2 mb-4 text-[12px] text-[#A1A1AA] leading-relaxed">
            <p><span className="text-[#71717A]">Category:</span> {project.category}</p>
            <p><span className="text-[#71717A]">Configuration:</span> {project.config}</p>
            <p><span className="text-[#71717A]">Scale:</span> {project.scale}</p>
            {project.possession && <p><span className="text-[#71717A]">Possession:</span> {project.possession}</p>}
            {project.developer && <p><span className="text-[#71717A]">Developer:</span> {project.developer}</p>}
          </div>
          <ul className="space-y-1.5 mb-5">
            {project.highlights.map((h) => (
              <li key={h} className="text-[12px] text-[#A1A1AA] flex gap-2">
                <span className="text-[#D4AF37]">&bull;</span>{h}
              </li>
            ))}
          </ul>
          <div className="mt-auto flex items-center justify-between gap-3 pt-2">
            <p className="flex items-center gap-1.5 text-[10px] text-[#52525b]">
              <ShieldCheck size={12} className="text-[#D4AF37]/60" /> RERA {project.rera}
            </p>
            <GoldButton
              data-testid={`project-card-${project.id}-enquire-btn`}
              variant="outline"
              className="px-5 py-2.5 text-[10px]"
              onClick={() => onEnquire(`${project.name}, ${project.sector}`)}
            >
              Enquire
            </GoldButton>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
